// extracted by mini-css-extract-plugin
export default {"videoContent":"youtube-embed_videoContent__dNxzL","video":"youtube-embed_video__JJd2q"};